import toast from 'react-hot-toast';

const CELEBRATION_KEYS = {
  SEGMENT_CREATED: 'segment_celebration_count',
  TRANSCRIPT_SAVED: 'transcript_celebration_count',
  TRANSLATION_SAVED: 'translation_celebration_count',
  LOOP_ACTIVATED: 'loop_celebration_count',
};

const MAX_CELEBRATIONS = 3;

/**
 * Shows a celebration toast if the count hasn't exceeded the maximum.
 * Increments the count in localStorage.
 */
export const showCelebrationToast = (
  key: keyof typeof CELEBRATION_KEYS,
  message: string,
  icon?: string
) => {
  const storageKey = CELEBRATION_KEYS[key];
  const currentCount = parseInt(localStorage.getItem(storageKey) || '0', 10);

  if (currentCount < MAX_CELEBRATIONS) {
    // Show toast after a natural delay
    setTimeout(() => {
      toast.success(message, { icon, duration: 3000 });
    }, 500);

    // Increment the count
    localStorage.setItem(storageKey, String(currentCount + 1));
  }
};

/**
 * Reset all celebration counts (useful for testing or user preferences)
 */
export const resetCelebrationCounts = () => {
  Object.values(CELEBRATION_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
};
